// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import UserSecurityList from 'components/organisms/UserSecurityList';
import PurchaseTemplate from 'components/templates/PurchaseTemplate';
import { useTranslation } from 'react-i18next';

const PurchaseUserSecurity: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PurchaseTemplate title={t('user_security.header')}>
      <UserSecurityList />
    </PurchaseTemplate>
  );
};

export default PurchaseUserSecurity;
